import { connect } from "react-redux";
import { Tag, Popover } from "antd";
import _ from "lodash";

const Skills = ({ val, skillCategorized, languageCategorized }) => {
  const skillsList = val?.person_search_obj?.skills?.list ?? [];

  if (skillsList.length === 0) {
    return (
      <p className="text-grayBlack text-xs font-medium">
        N/A
      </p>
    );
  }

  const skillMap = Object.assign(
    {},
    ...skillCategorized.map((obj) => {
      const key = Object.keys(obj)[0];
      const value = Object.values(obj)[0];
      return { [value]: key };
    })
  );

  const languageMap = Object.assign(
    {},
    ...languageCategorized.map((obj) => {
      const key = Object.keys(obj)[0];
      const value = Object.values(obj)[0];
      return { [value]: key };
    })
  );

  const skillContents = skillsList.reduce((acc, skill) => {
    if (skillMap[skill]) {
      return [...acc, skillMap[skill]];
    }

    if (languageMap[skill]) {
      return [...acc, languageMap[skill]];
    }

    return acc;
  }, []);

  const DISPLAY_LIMIT = 5;
  const visibleSkills = skillContents.slice(0, DISPLAY_LIMIT);
  const hasOverflow = skillContents.length > DISPLAY_LIMIT;

  return (
    <>
      {visibleSkills.map((skill) => (
        <Tag
          key={skill}
          color="#E0E4EB"
          style={{
            color: "#0A0C10",
            fontSize: "12px",
            fontWeight: 500,
            marginInlineEnd: "2px",
            textTransform: "capitalize",
          }}
          bordered={false}
        >
          {skill}
        </Tag>
      ))}

      {hasOverflow && (
        <Popover
          placement="right"
          overlayClassName="event-shift-popover"
          content={
            <div>
              {skillContents.map((skill, i) => (
                <span
                  key={`${skill}-${i}`}
                  className="text-grayMuted text-xs font-medium capitalize"
                >
                  {skill}
                  {i < skillContents.length - 1 ? ", " : ""}
                </span>
              ))}
            </div>
          }
        >
          <Tag
            color="#E0E4EB"
            style={{
              color: "#0A0C10",
              fontSize: "12px",
              fontWeight: 500,
              marginInlineEnd: "2px",
            }}
            bordered={false}
          >
            +{skillContents.length - DISPLAY_LIMIT} more
          </Tag>
        </Popover>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  skillCategorized: state.talent.skillCategorized,
  languageCategorized: state.talent.languageCategorized,
});

export default connect(mapStateToProps)(Skills);
